<div class="min-h-screen flex flex-col items-center justify-center bg-white">
  <div class="flex flex-col gap-10 items-center max-w-[1280px] w-full px-6">
    <!-- Logo -->
    <div class="h-10 w-auto">
      <img src="/icons/esignatur-logo.svg" alt="Esignatur" class="h-full w-auto object-contain" />
    </div>

    <!-- Cloud Network Icon -->
    <div class="w-[400px] h-[400px]">
      <img
        src="/icons/cloud-network-duplicate-tab.svg"
        alt="Duplicate tab detected"
        class="w-full h-full object-contain"
      />
    </div>

    <!-- Title & Description -->
    <div class="flex flex-col items-center w-full">
      <div class="flex flex-col items-center text-center">
        <p class="text-[36px] font-bold leading-[1.8] text-[#005d7a] mb-0">
          {{ 'TAB_DETECTION.TITLE' | transloco }}
        </p>
        <p class="text-[24px] font-medium leading-[1.8] text-[#005d7a]">
          {{ 'TAB_DETECTION.SUBTITLE' | transloco }}
        </p>
      </div>
    </div>
  </div>
</div>
